const formFieldsInitial = [
	{
		id: "tipo_consumidor",
		label: "Tipo",
		type: "select",
		size: 2,
		options: [
			{ value: "F", label: "Consumidor Final" },
			{ value: "R", label: "Revendedor" },
			{ value: "X", label: "Exportação" },
		],
		required: true,
		error: false,
		mostrarEmTipo: ["F", "R", "X"],
	},
	{
		id: "pais_id",
		label: "País",
		type: "listaPaises",
		size: 2,
		options: [],
		required: true,
		error: false,
		mostrarEmTipo: ["X"],
	},
	{
		id: "genero",
		label: "Gênero",
		type: "select",
		size: 2,
		options: [
			{ value: "F", label: "Feminino" },
			{ value: "M", label: "Masculino" },
			{ value: "E", label: "Empresa" },
		],
		required: true,
		error: false,
		mostrarEmTipo: ["F", "R", "X"],
	},
	{
		id: "nome",
		label: "Nome",
		type: "text",
		size: 4,
		maxLength: 100,
		required: true,
		error: false,
		mostrarEmTipo: ["F", "R", "X"],
	},
	{
		id: "email",
		label: "E-mail",
		type: "text",
		size: 4,
		maxLength: 50,
		required: true,
		error: false,
		mostrarEmTipo: ["F", "R", "X"],
	},
	{
		id: "ddd",
		label: "DDD",
		type: "text",
		size: 1,
		maxLength: 4,
		required: true,
		error: false,
		mostrarEmTipo: ["F", "R", "X"],
	},
	{
		id: "telefone_sem_ddd",
		label: "Telefone",
		type: "text",
		size: 2,
		maxLength: 30,
		required: true,
		error: false,
		mostrarEmTipo: ["F", "R", "X"],
	},
	{
		id: "documento",
		label: "Documento",
		type: "numeros",
		size: 3,
		maxLength: 18,
		required: true,
		error: false,
		mostrarEmTipo: ["F", "R"],
	},
	{
		id: "contribuinte_estadual",
		label: "Contribuinte Estadual",
		type: "select_vf",
		size: 4,
		options: [
			{ value: "0", label: "Não" },
			{ value: "1", label: "Sim" },
		],
		required: false,
		error: false,
		mostrarEmTipo: ["F", "R"],
	},
	{
		id: "inscricao_estadual",
		label: "Inscricao Estadual",
		type: "text",
		size: 4,
		maxLength: 100,
		required: false,
		error: false,
		mostrarEmTipo: ["F", "R"],
	},
	{
		id: "inscricao_municipal",
		label: "Inscricao Municipal",
		type: "text",
		size: 4,
		maxLength: 100,
		required: false,
		error: false,
		mostrarEmTipo: ["F", "R"],
	},
	{
		id: "cep",
		label: "CEP",
		type: "text",
		size: 3,
		maxLength: 9,
		required: true,
		error: false,
		mostrarEmTipo: ["F", "R", "X"],
	},
	{
		id: "endereco",
		label: "Endereço",
		type: "text",
		size: 6,
		maxLength: 200,
		required: true,
		error: false,
		mostrarEmTipo: ["F", "R", "X"],
	},
	{
		id: "complemento",
		label: "Complemento",
		type: "text",
		size: 3,
		maxLength: 100,
		required: false,
		error: false,
		mostrarEmTipo: ["F", "R", "X"],
	},
	{
		id: "bairro",
		label: "Bairro",
		type: "text",
		size: 3,
		maxLength: 100,
		required: true,
		error: false,
		mostrarEmTipo: ["F", "R", "X"],
	},
	{
		id: "estado",
		label: "Estado",
		type: "select",
		options: [
			{ value: "AC", label: "Acre" },
			{ value: "AL", label: "Alagoas" },
			{ value: "AP", label: "Amapá" },
			{ value: "AM", label: "Amazonas" },
			{ value: "BA", label: "Bahia" },
			{ value: "CE", label: "Ceará" },
			{ value: "DF", label: "Distrito Federal" },
			{ value: "ES", label: "Espírito Santo" },
			{ value: "GO", label: "Goiás" },
			{ value: "MA", label: "Maranhão" },
			{ value: "MT", label: "Mato Grosso" },
			{ value: "MS", label: "Mato Grosso do Sul" },
			{ value: "MG", label: "Minas Gerais" },
			{ value: "PA", label: "Pará" },
			{ value: "PB", label: "Paraíba" },
			{ value: "PR", label: "Paraná" },
			{ value: "PE", label: "Pernambuco" },
			{ value: "PI", label: "Piauí" },
			{ value: "RJ", label: "Rio de Janeiro" },
			{ value: "RN", label: "Rio Grande do Norte" },
			{ value: "RS", label: "Rio Grande do Sul" },
			{ value: "RO", label: "Rondônia" },
			{ value: "RR", label: "Roraima" },
			{ value: "SC", label: "Santa Catarina" },
			{ value: "SP", label: "São Paulo" },
			{ value: "SE", label: "Sergipe" },
			{ value: "TO", label: "Tocantins" },
		],
		size: 2,
		maxLength: 2,
		required: true,
		error: false,
		mostrarEmTipo: ["F", "R"],
	},
	{
		id: "municipio",
		label: "Município",
		type: "text",
		size: 3,
		maxLength: 100,
		required: true,
		error: false,
		mostrarEmTipo: ["F", "R", "X"],
	},
	{
		id: "cep_entrega",
		label: "CEP",
		type: "text",
		size: 3,
		maxLength: 9,
		required: true,
		error: false,
		mostrarEmTipo: ["F", "R", "X"],
	},
	{
		id: "endereco_entrega",
		label: "Endereço",
		type: "text",
		size: 6,
		maxLength: 200,
		required: true,
		error: false,
		mostrarEmTipo: ["F", "R", "X"],
	},
	{
		id: "complemento_entrega",
		label: "Complemento",
		type: "text",
		size: 3,
		maxLength: 100,
		required: false,
		error: false,
		mostrarEmTipo: ["F", "R", "X"],
	},
	{
		id: "bairro_entrega",
		label: "Bairro",
		type: "text",
		size: 3,
		maxLength: 100,
		required: true,
		error: false,
		mostrarEmTipo: ["F", "R", "X"],
	},
	{
		id: "estado_entrega",
		label: "Estado",
		type: "select",
		options: [
			{ value: "AC", label: "Acre" },
			{ value: "AL", label: "Alagoas" },
			{ value: "AP", label: "Amapá" },
			{ value: "AM", label: "Amazonas" },
			{ value: "BA", label: "Bahia" },
			{ value: "CE", label: "Ceará" },
			{ value: "DF", label: "Distrito Federal" },
			{ value: "ES", label: "Espírito Santo" },
			{ value: "GO", label: "Goiás" },
			{ value: "MA", label: "Maranhão" },
			{ value: "MT", label: "Mato Grosso" },
			{ value: "MS", label: "Mato Grosso do Sul" },
			{ value: "MG", label: "Minas Gerais" },
			{ value: "PA", label: "Pará" },
			{ value: "PB", label: "Paraíba" },
			{ value: "PR", label: "Paraná" },
			{ value: "PE", label: "Pernambuco" },
			{ value: "PI", label: "Piauí" },
			{ value: "RJ", label: "Rio de Janeiro" },
			{ value: "RN", label: "Rio Grande do Norte" },
			{ value: "RS", label: "Rio Grande do Sul" },
			{ value: "RO", label: "Rondônia" },
			{ value: "RR", label: "Roraima" },
			{ value: "SC", label: "Santa Catarina" },
			{ value: "SP", label: "São Paulo" },
			{ value: "SE", label: "Sergipe" },
			{ value: "TO", label: "Tocantins" },
		],
		size: 2,
		maxLength: 2,
		required: true,
		error: false,
		mostrarEmTipo: ["F", "R"],
	},
	{
		id: "municipio_entrega",
		label: "Município",
		type: "text",
		size: 3,
		maxLength: 100,
		required: true,
		error: false,
		mostrarEmTipo: ["F", "R", "X"],
	},
];

export default formFieldsInitial;
